import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FileUploader } from "react-drag-drop-files";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import {
  validateIncomeProof,
  getAddressByPincode,
  uploadReactivateProofApi,
} from "designs/v1/pages/ModifyKyc/services";
import {
  isEmptyObject,
  validateOnNumber,
  validateOnPaste,
  jsonToFormData,
  getApiUrl,
  MARFATIA_API_URL
} from "utils";
import { handleFileResizer } from "utils/imageResizer";

const AddressProof = ({
  activeUserDetail,
  isLoading,
  setIsLoading,
  setStep,
}) => {
  const timeout = useRef();
  const proofTypes = [
    { name: "None", value: "" },
    ...(getApiUrl() === MARFATIA_API_URL ? [{ name: "Aadhaar", value: "Aadhaar" }] : []),
    { name: "Voter ID", value: "VoterID" },
    { name: "Passport", value: "Passport" },
    { name: "Driving License", value: "DrivingLicense" },
  ];
  const [initialValues, setInitialValues] = useState({
    type: "",
    file1: "",
    file2: "",
    file_type: "Image",
    // address: {
    //   address_line1: "",
    //   city: "",
    //   pincode: "",
    //   state: "",
    //   country: "India",
    // },
  });
  const [hasAddress, setHasAddress] = useState(false);

  const handleValidate = (values) => {
    const errors = {};
    // if (!values.address.address_line1) {
    //   errors.address = { address_line1: "Address is Required" };
    // }
    // if (!values.address.city && !values.address.state) {
    //   errors.address = { pincode: "Invalid pincode" };
    // }
    // if (!values.address.pincode) {
    //   errors.address = { pincode: "Pincode is Required" };
    // }
    return errors;
  };

  const validateProof = (values) => {
    const { type, file1, file2 } = values;
    let valid = false;
    if (
      !type ||
      (["DrivingLicense"].includes(type) && !file1) ||
      (!["DrivingLicense"].includes(type) && (!file1 || !file2))
    ) {
      valid = true;
    }
    return valid;
  };

  const onUploadProof = async (values, setFieldValue) => {
    setIsLoading(true);
    const formValue = {
      doc_name: activeUserDetail?.request_number,
      ...values,
    };
    if (
      formValue.file1?.type === "application/pdf" ||
      formValue.file2?.type === "application/pdf"
    ) {
      formValue.file_type = "pdf";
    }
    delete formValue["address"];
    const payload = jsonToFormData(formValue);
    try {
      const resp = await uploadReactivateProofApi(payload);
      const data = resp.data?.data;
      if (resp.data?.message?.message) {
        toast.success(resp.data.message.message);
      }
      setHasAddress(true);
      setIsLoading(false);
      setFieldValue(
        "address.address_line1",
        data?.corr_address_line1?.toUpperCase() ?? ""
      );
      onSearchPincode(data?.corr_pincode || "", setFieldValue);
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!");
      setIsLoading(false);
    }
  };

  const handleSubmit = async (value) => {
    setIsLoading(true);
    const formValue = {
      request_type: "Reactivation",
      doc_name: activeUserDetail?.request_number,
      address: value.address,
      ...value,
    };
    if (
      formValue.file1?.type === "application/pdf" ||
      formValue.file2?.type === "application/pdf"
    ) {
      formValue.file_type = "pdf";
    }
    delete formValue["address"];
    const payload = jsonToFormData(formValue);
    try {
      const resp = await uploadReactivateProofApi(payload);
      console.log("resp", resp.data);
      setIsLoading(false);
      setStep("PersonalDetails");
      toast.success("Address proof submitted successfully.");
    } catch (error) {
      const { data } = error.response || {};
      toast.error(data.message || "Internal server error!");
      setIsLoading(false);
    }
    // try {
    //   const resp = await updateReactivateAddressApi(formValue);
    //   console.log("resp", resp.data);
    //   try {
    //     const payload = {
    //       request_type: "Reactivation",
    //       doc_name: activeUserDetail?.request_number,
    //     };
    //     await Promise.all([
    //       reactivateForSendPdfApi(payload),
    //       reactivateForEsignApi(payload),
    //     ]);
    //     setIsLoading(false);
    //     setStep("ESignature");
    //     toast.success("Request for Esign submitted successfully.");
    //   } catch (error) {
    //     setIsLoading(false);
    //     const { data } = error.response || {};
    //     toast.error(data.message || "Internal server error!.");
    //   }
    // } catch (error) {
    //   const { data } = error.response || {};
    //   toast.error(data.message || "Internal server error!");
    //   setIsLoading(false);
    // }
  };

  const handleFileUpload = async (name, file, setFieldValue) => {
    if (!file) {
      return setFieldValue(name, "");
    }
    const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
    if (!allowed_types.includes(file.type)) {
      setFieldValue(name, "");
      return toast.error(
        "Only Images/Pdf are allowed ( JPG | PNG | PDF )",
        "Error"
      );
    }
    const fileSize = file.size / 1024 ** 2;
    if (fileSize >= 4) {
      setFieldValue(name, "");
      return toast.error("Error: Please upload a file smaller than 4 MB");
    }
    if (file.type === "application/pdf") {
      setFieldValue("file_type", "pdf");
      setIsLoading(true);
      try {
        const resp = await validateIncomeProof(jsonToFormData({ file }));
        const isEncrypted = resp.data?.message;
        if (isEncrypted) {
          setFieldValue(name, "");
          toast.error("Please upload a file without password protected.");
        } else {
          setFieldValue(name, file);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setFieldValue(name, "");
        toast.error("Internal server error!");
      }
    } else {
      setFieldValue("file_type", "Image");
      const img = new Image();
      img.src = window.URL.createObjectURL(file);
      img.onload = async () => {
        if (img.width >= 400 && img.height >= 350) {
          const newFile = await handleFileResizer(file);
          setFieldValue(name, newFile);
        } else {
          setFieldValue(name, "");
          return toast.error(
            `The image you uploaded is of lower resolution. Please upload a higher resolution image.`
          );
        }
      };
    }
  };

  const getPermanentAddress = (address) => {
    const { city, state } = address ?? {};
    let html = [];
    if (city) {
      html.push(
        <span style={{ fontSize: "12px", margin: "0 2px" }}>{city}</span>
      );
    }
    if (state) {
      html.push(
        <span style={{ fontSize: "12px", margin: "0 2px" }}>{state}</span>
      );
    }
    return html;
  };

  const getAddressInfo = async (value, setFieldValue) => {
    setIsLoading(true);
    let payload = { pincode: value };
    try {
      const resp = await getAddressByPincode(payload);
      const data = resp.data?.data ?? {};
      setIsLoading(false);
      if (isEmptyObject(data)) {
        return null;
      }
      setFieldValue("address.city", data.DistrictName);
      setFieldValue("address.state", data.StateName);
    } catch (error) {
      setIsLoading(false);
      setFieldValue("address.city", "");
      setFieldValue("address.state", "");
    }
  };

  const onSearchPincode = (value, setFieldValue) => {
    setFieldValue("address.pincode", value);
    if (value.length > 5) {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(() => {
        getAddressInfo(value, setFieldValue);
      }, 250);
    } else {
      setFieldValue("address.city", "");
      setFieldValue("address.state", "");
    }
  };

  return (
    <React.Fragment>
      <Title title="Upload your Address proof" />
      <div className="row">
        <div className="col-md-9">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                initialValues={initialValues}
                handleValidate={handleValidate}
                onSubmit={handleSubmit}
              >
                {({ values, setFieldValue }) => (
                  <Form>
                    <div className="form-group my-2">
                      <label className="py-1">Proof Type</label>
                      <Field
                        as="select"
                        name="type"
                        className="form-select"
                        onChange={({ target }) => {
                          setFieldValue("type", target.value);
                          setFieldValue("file1", "");
                          setFieldValue("file2", "");
                          setFieldValue("address", {
                            address_line1: "",
                            city: "",
                            pincode: "",
                            state: "",
                            country: "India",
                          });
                          setHasAddress(false);
                        }}
                      >
                        {proofTypes.map((option, index) => {
                          return (
                            <option
                              key={index}
                              value={option.value}
                            >
                              {option.name}
                            </option>
                          );
                        })}
                      </Field>
                    </div>
                    <div className="form-group my-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="py-1">Front Image</label>
                        <div className="file_limit_text">
                          Maximum file size: 4 MB
                        </div>
                      </div>
                      <Field name="file1">
                        {(props) => (
                          <div className="file-uploader-container">
                            <FileUploader
                              {...props}
                              key={values.type}
                              label="Upload or drop a file here"
                              handleChange={(file) =>
                                handleFileUpload("file1", file, setFieldValue)
                              }
                              name="file"
                              types={["JPG", "JPEG", "PNG", "PDF"]}
                            />
                          </div>
                        )}
                      </Field>
                      {values?.file1 && (
                        <p>
                          <small>File name: {values.file1?.name}</small>
                        </p>
                      )}
                    </div>
                    {!["PAN", "DrivingLicense"].includes(values.type) && (
                      <div className="form-group my-2">
                        <div className="d-flex align-items-center justify-content-between">
                          <label className="py-1">Back Image</label>
                          <div className="file_limit_text">
                            Maximum file size: 4 MB
                          </div>
                        </div>
                        <Field name="file2">
                          {(props) => (
                            <div className="file-uploader-container">
                              <FileUploader
                                {...props}
                                key={values.type}
                                label="Upload or drop a file here"
                                handleChange={(file) =>
                                  handleFileUpload("file2", file, setFieldValue)
                                }
                                name="file"
                                types={["JPG", "JPEG", "PNG", "PDF"]}
                              />
                            </div>
                          )}
                        </Field>
                        {values?.file2 && (
                          <p>
                            <small>File name: {values.file2?.name}</small>
                          </p>
                        )}
                      </div>
                    )}

                    <div style={{ display: "none" }}>
                      <div className="mt-4">
                        <Button
                          title="Upload"
                          type="button"
                          disabled={isLoading || validateProof(values)}
                          name="Submit"
                          handleClick={() =>
                            onUploadProof(values, setFieldValue)
                          }
                        ></Button>
                      </div>

                      <div className="form-group my-2">
                        <label className="py-1">Address</label>
                        <Field
                          name="address.address_line1"
                          placeholder="Address"
                          className="form-control"
                          as="textarea"
                          disabled={!hasAddress}
                        />
                        <ErrorMessage
                          name="address.address_line1"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>

                      <div className="form-group my-2">
                        <label className="py-1">Pincode</label>
                        <Field
                          name="address.pincode"
                          placeholder="Pincode"
                          className="form-control"
                          onPaste={validateOnPaste}
                          onKeyPress={validateOnNumber}
                          onChange={({ target }) =>
                            onSearchPincode(target.value, setFieldValue)
                          }
                          maxLength="6"
                          disabled={!hasAddress}
                        />
                        <ErrorMessage
                          name="address.pincode"
                          className="inline-errormsg my-1"
                          component="div"
                        />
                      </div>

                      <div className="d-flex">
                        {getPermanentAddress(values.address)}
                      </div>
                    </div>

                    <div className="d-flex my-4">
                      <div className="mx-1">
                        <Button
                          type="button"
                          title="Back"
                          handleClick={() => setStep("PanProof")}
                          disabled={isLoading}
                        />
                      </div>
                      <div className="mx-1">
                        <Button
                          title="Submit"
                          disabled={isLoading || validateProof(values)}
                        />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddressProof;
